// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___eb42332c88ee1fdff9e{/*!*/}.SeasonalDiscountUnibrow-cls2__d7d5a27a10387b17c2de{color:#fff;font-size:12px;font-weight:400;margin:0 0 3px;opacity:.8;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___eb42332c88ee1fdff9e",
	"cls2": "SeasonalDiscountUnibrow-cls2__d7d5a27a10387b17c2de SeasonalDiscountUnibrow-cls1___eb42332c88ee1fdff9e"
};
export default ___CSS_LOADER_EXPORT___;
